import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()
export class TenantVariablesService {

  private readonly tenantVariables = new BehaviorSubject<Record<string, string>>({});

  public getTenantVariables$(): Observable<Record<string, string>> {
    return this.tenantVariables;
  }

  public setTenantVariables(tenantVariables: Record<string, string>): void {
    this.tenantVariables.next(tenantVariables);
  }

}
